import http from '../index'

export default {
	// 账号相关接口
	account: {
		// 发送短信验证码
		sendSmsCode: (phone, options) =>
			http.get(`/api/sendSmsCode`, { phone, type: 1 }, options),
		// 登录
		login: (data, options) => http.post(`/api/login`, data, options),
		// 获取微信公众号授权信息
		getWxInfo: data => http.get(`/wechat/authorize`, data),
		// 获取用户信息
		getUserDetail: () => http.get(`/user/userDetail`),
		// 退出登录
		logout: () => http.post(`/api/logout`),
		// 获取当前服务器时间
		getDateTime: () => http.get(`api/currentTime`)
	},
	// 订单列表接口
	order: {
		// 列表接口
		page: data => http.post(`/detect/order/page`, data),
		// 详情接口
		detail: id => http.get(`/detect/order/detail/${id}`),
		// 开具发票
		issueInvoice: data => http.post(`/detectInvoice/issueInvoice`, data),
		// 药物字典
		drugList: data => http.get(`/detect/order/drug/list`, data),
		// 样本类型字典
		sampleList: data => http.get(`/detect/sample/list?status=1`, data),
		// 订单完成后自动生成报告解读订单启用/停用
		autoReadReport: data => http.get(`/detect/order/autoReadReport`, data)
	},
	pay: {
		wxPayOrder: data => http.post(`/detect/order/payOrder`, data)
	}
}
